module.exports = {
    back: 'Back',
    allCourses: 'All courses',
    instruction: 'Here you can access all courses created by you.',
    noCourses: 'You have no courses! Create one right now by going back to the home page.',
}